
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "Whatsapp_52e11d315ed4c3cd__b",
  d: "M0 0h16.602v16.425H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8.189c0 2.648 1.613 4.857 1.613 4.857l-1.01 2.981 3.113-1.004s2.027 1.355 4.561 1.355c4.571 0 8.277-3.667 8.277-8.19C16.554 3.667 12.848 0 8.277 0S0 3.666 0 8.189m10.471 4.554c-.589-.163-2.538-.667-3.808-1.839s-2.3-2.406-2.72-3.316c-.421-.91-.398-1.45-.374-1.705.023-.254.158-1.433.956-1.938 0 0 .266-.167.405-.167h.777s.208.035.303.25.75 1.736.799 1.853c.048.118.176.408-.028.668-.204.26-.63.746-.63.746s-.169.15-.023.39c.146.239.66 1.028 1.333 1.625.673.596 1.497 1.035 1.907 1.168.411.134.501-.044.658-.244.158-.2.648-.813.648-.813s.169-.245.5-.095c.332.15 1.947.924 1.947.924s.197.034.208.25c.01.218.146.867-.44 1.492-.476.51-1.392.796-2.033.796-.145 0-.276-.015-.385-.045",
  id: "Whatsapp_52e11d315ed4c3cd__d"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "39.433%",
  y1: "88.596%",
  x2: "60.566%",
  y2: "11.404%",
  id: "Whatsapp_52e11d315ed4c3cd__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BA57",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BA57",
  offset: "25%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BA58",
  offset: "37.5%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BB58",
  offset: "43.75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#41BB58",
  offset: "50%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42BB59",
  offset: "53.125%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42BB59",
  offset: "56.25%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BB59",
  offset: "59.375%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44BC5A",
  offset: "60.938%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44BC5A",
  offset: "62.5%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#45BC5A",
  offset: "64.063%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46BC5B",
  offset: "65.625%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46BD5B",
  offset: "67.188%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#47BD5C",
  offset: "68.75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48BD5C",
  offset: "70.313%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#49BD5D",
  offset: "71.094%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#49BD5D",
  offset: "71.875%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4ABE5D",
  offset: "72.656%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4ABE5D",
  offset: "73.438%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BBE5E",
  offset: "74.219%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BBE5E",
  offset: "75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CBE5E",
  offset: "75.781%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CBF5F",
  offset: "76.563%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DBF5F",
  offset: "77.344%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4EBF60",
  offset: "78.125%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4EBF60",
  offset: "78.906%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FBF60",
  offset: "79.688%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#50C061",
  offset: "80.469%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#51C061",
  offset: "81.25%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#51C062",
  offset: "82.031%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52C162",
  offset: "82.813%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#53C163",
  offset: "83.594%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54C163",
  offset: "83.984%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54C164",
  offset: "84.375%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#55C164",
  offset: "84.766%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#55C264",
  offset: "85.156%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56C264",
  offset: "85.547%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56C265",
  offset: "85.938%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57C265",
  offset: "86.328%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57C265",
  offset: "86.719%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58C266",
  offset: "87.109%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58C366",
  offset: "87.5%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59C366",
  offset: "87.891%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59C367",
  offset: "88.281%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5AC367",
  offset: "88.672%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5AC367",
  offset: "89.063%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BC468",
  offset: "89.453%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BC468",
  offset: "89.844%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5CC468",
  offset: "90.234%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5DC469",
  offset: "90.625%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5DC469",
  offset: "91.016%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5EC56A",
  offset: "91.406%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5EC56A",
  offset: "91.797%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5FC56A",
  offset: "92.188%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#60C56B",
  offset: "92.578%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#60C56B",
  offset: "92.969%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61C66C",
  offset: "93.359%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#62C66C",
  offset: "93.75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#62C66D",
  offset: "94.141%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#63C66D",
  offset: "94.531%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#64C76E",
  offset: "94.922%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#64C76E",
  offset: "95.313%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#65C76E",
  offset: "95.703%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66C76F",
  offset: "96.094%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66C76F",
  offset: "96.875%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66C76F",
  offset: "100%"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-60%",
  y: "-60%",
  width: "220%",
  height: "220%",
  filterUnits: "objectBoundingBox",
  id: "Whatsapp_52e11d315ed4c3cd__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#Whatsapp_52e11d315ed4c3cd__a)",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.146 17.937c-2.533 0-4.561-1.354-4.561-1.354l-3.113 1.004 1.01-2.98S1.87 12.396 1.87 9.747c0-4.522 3.706-8.188 8.277-8.188 4.572 0 8.277 3.666 8.277 8.188 0 4.523-3.705 8.19-8.277 8.19m0-17.938C4.704 0 .293 4.365.293 9.748c0 2.673 1.43 5.061 1.43 5.061L0 20l5.4-1.707s2.003 1.204 4.746 1.204c5.442 0 9.854-4.365 9.854-9.749C20 4.365 15.588 0 10.146 0",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.84 1.558)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "Whatsapp_52e11d315ed4c3cd__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Whatsapp_52e11d315ed4c3cd__b"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#Whatsapp_52e11d315ed4c3cd__c)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.028 .002)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "Whatsapp_52e11d315ed4c3cd__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Whatsapp_52e11d315ed4c3cd__d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Whatsapp_52e11d315ed4c3cd__e)",
  fillRule: "nonzero",
  mask: "url(#Whatsapp_52e11d315ed4c3cd__f)",
  d: "M15.445 20.472-4.139 15.28 1.11-4.094l19.584 5.191z"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M15.198 12.06c.01.217.146.867-.44 1.491-.584.626-1.828.915-2.418.752-.589-.163-2.537-.667-3.808-1.84-1.27-1.172-2.3-2.406-2.72-3.315-.421-.91-.398-1.45-.374-1.705.023-.254.158-1.433.956-1.938 0 0 .266-.167.405-.167h.777s.208.035.303.25c.096.214.75 1.736.799 1.853.049.117.176.408-.028.668-.204.26-.63.746-.63.746s-.169.15-.023.39c.146.239.66 1.028 1.333 1.624.673.597 1.497 1.035 1.908 1.17.41.133.5-.045.658-.246.157-.2.647-.812.647-.812s.169-.245.5-.095c.332.15 1.947.924 1.947.924s.197.033.208.25",
  fill: "#FFF",
  fillRule: "nonzero"
})))));

      const __svgRaw = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>icon/24/Whatsapp</title>\r\n    <defs>\r\n        <filter x=\"-60.0%\" y=\"-60.0%\" width=\"220.0%\" height=\"220.0%\" filterUnits=\"objectBoundingBox\" id=\"filter-1\">\r\n            <feOffset dx=\"0\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur>\r\n            <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0\" type=\"matrix\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"></feColorMatrix>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"></feMergeNode>\r\n                <feMergeNode in=\"SourceGraphic\"></feMergeNode>\r\n            </feMerge>\r\n        </filter>\r\n        <polygon id=\"path-2\" points=\"0 0 16.6024224 0 16.6024224 16.4250858 0 16.4250858\"></polygon>\r\n        <path d=\"M0,8.18850534 C0,10.8373396 1.61347485,13.0462678 1.61347485,13.0462678 L0.603226195,16.0272908 L3.71563237,15.0227724 C3.71563237,15.0227724 5.74343704,16.3775529 8.27727943,16.3775529 C12.8484262,16.3775529 16.5541935,12.7111874 16.5541935,8.18850534 C16.5541935,3.66636542 12.8484262,0 8.27727943,0 C3.70576735,0 0,3.66636542 0,8.18850534 M10.4711449,12.7431773 C9.8819854,12.5803362 7.93346609,12.0760889 6.66343923,10.9040304 C5.39268164,9.73161033 4.36379913,8.49756008 3.94289264,7.58810771 C3.52198616,6.67793239 3.54536985,6.13789986 3.56875355,5.8834267 C3.59213724,5.62895354 3.72732422,4.45002709 4.52511004,3.94487621 C4.52511004,3.94487621 4.79128227,3.7778782 4.93012295,3.7778782 L5.70653463,3.7778782 C5.70653463,3.7778782 5.91461297,3.81348274 6.00997458,4.02819447 C6.10533622,4.24272548 6.76026232,5.76414241 6.80885658,5.8812579 C6.85745079,5.99873488 6.98459963,6.28917402 6.78072305,6.54924994 C6.57684647,6.80932586 6.1508248,7.29513826 6.1508248,7.29513826 C6.1508248,7.29513826 5.98202377,7.44496655 6.12835452,7.68480029 C6.27431994,7.92391109 6.78876119,8.71317547 7.46122505,9.30959694 C8.13423698,9.90601841 8.95778144,10.3446593 9.36845756,10.4784023 C9.778951,10.6121453 9.86938014,10.4339418 10.0264893,10.233508 C10.1839639,10.033255 10.6737427,9.42110972 10.6737427,9.42110972 C10.6737427,9.42110972 10.8425437,9.17585394 11.1741171,9.32622445 C11.5062387,9.47659495 13.1206269,10.2503163 13.1206269,10.2503163 C13.1206269,10.2503163 13.3175615,10.2835713 13.3287053,10.5006326 C13.3398491,10.7175131 13.4750361,11.3670703 12.8898956,11.9916862 C12.4129049,12.5015362 11.4972871,12.7879993 10.8560624,12.7878186 C10.7110104,12.7878186 10.5798425,12.7731791 10.4711449,12.7431773\" id=\"path-4\"></path>\r\n        <linearGradient x1=\"39.433258%\" y1=\"88.5957735%\" x2=\"60.5657278%\" y2=\"11.4041474%\" id=\"linearGradient-6\">\r\n            <stop stop-color=\"#40BA57\" offset=\"0%\"></stop>\r\n            <stop stop-color=\"#40BA57\" offset=\"25%\"></stop>\r\n            <stop stop-color=\"#40BA58\" offset=\"37.5%\"></stop>\r\n            <stop stop-color=\"#40BB58\" offset=\"43.75%\"></stop>\r\n            <stop stop-color=\"#41BB58\" offset=\"50%\"></stop>\r\n            <stop stop-color=\"#42BB59\" offset=\"53.125%\"></stop>\r\n            <stop stop-color=\"#42BB59\" offset=\"56.25%\"></stop>\r\n            <stop stop-color=\"#43BB59\" offset=\"59.375%\"></stop>\r\n            <stop stop-color=\"#44BC5A\" offset=\"60.9375%\"></stop>\r\n            <stop stop-color=\"#44BC5A\" offset=\"62.5%\"></stop>\r\n            <stop stop-color=\"#45BC5A\" offset=\"64.0625%\"></stop>\r\n            <stop stop-color=\"#46BC5B\" offset=\"65.625%\"></stop>\r\n            <stop stop-color=\"#46BD5B\" offset=\"67.1875%\"></stop>\r\n            <stop stop-color=\"#47BD5C\" offset=\"68.75%\"></stop>\r\n            <stop stop-color=\"#48BD5C\" offset=\"70.3125%\"></stop>\r\n            <stop stop-color=\"#49BD5D\" offset=\"71.0938%\"></stop>\r\n            <stop stop-color=\"#49BD5D\" offset=\"71.875%\"></stop>\r\n            <stop stop-color=\"#4ABE5D\" offset=\"72.6563%\"></stop>\r\n            <stop stop-color=\"#4ABE5D\" offset=\"73.4375%\"></stop>\r\n            <stop stop-color=\"#4BBE5E\" offset=\"74.2188%\"></stop>\r\n            <stop stop-color=\"#4BBE5E\" offset=\"75%\"></stop>\r\n            <stop stop-color=\"#4CBE5E\" offset=\"75.7813%\"></stop>\r\n            <stop stop-color=\"#4CBF5F\" offset=\"76.5625%\"></stop>\r\n            <stop stop-color=\"#4DBF5F\" offset=\"77.3438%\"></stop>\r\n            <stop stop-color=\"#4EBF60\" offset=\"78.125%\"></stop>\r\n            <stop stop-color=\"#4EBF60\" offset=\"78.9063%\"></stop>\r\n            <stop stop-color=\"#4FBF60\" offset=\"79.6875%\"></stop>\r\n            <stop stop-color=\"#50C061\" offset=\"80.4688%\"></stop>\r\n            <stop stop-color=\"#51C061\" offset=\"81.25%\"></stop>\r\n            <stop stop-color=\"#51C062\" offset=\"82.0313%\"></stop>\r\n            <stop stop-color=\"#52C162\" offset=\"82.8125%\"></stop>\r\n            <stop stop-color=\"#53C163\" offset=\"83.5938%\"></stop>\r\n            <stop stop-color=\"#54C163\" offset=\"83.9844%\"></stop>\r\n            <stop stop-color=\"#54C164\" offset=\"84.375%\"></stop>\r\n            <stop stop-color=\"#55C164\" offset=\"84.7656%\"></stop>\r\n            <stop stop-color=\"#55C264\" offset=\"85.1563%\"></stop>\r\n            <stop stop-color=\"#56C264\" offset=\"85.5469%\"></stop>\r\n            <stop stop-color=\"#56C265\" offset=\"85.9375%\"></stop>\r\n            <stop stop-color=\"#57C265\" offset=\"86.3281%\"></stop>\r\n            <stop stop-color=\"#57C265\" offset=\"86.7188%\"></stop>\r\n            <stop stop-color=\"#58C266\" offset=\"87.1094%\"></stop>\r\n            <stop stop-color=\"#58C366\" offset=\"87.5%\"></stop>\r\n            <stop stop-color=\"#59C366\" offset=\"87.8906%\"></stop>\r\n            <stop stop-color=\"#59C367\" offset=\"88.2813%\"></stop>\r\n            <stop stop-color=\"#5AC367\" offset=\"88.6719%\"></stop>\r\n            <stop stop-color=\"#5AC367\" offset=\"89.0625%\"></stop>\r\n            <stop stop-color=\"#5BC468\" offset=\"89.4531%\"></stop>\r\n            <stop stop-color=\"#5BC468\" offset=\"89.8438%\"></stop>\r\n            <stop stop-color=\"#5CC468\" offset=\"90.2344%\"></stop>\r\n            <stop stop-color=\"#5DC469\" offset=\"90.625%\"></stop>\r\n            <stop stop-color=\"#5DC469\" offset=\"91.0156%\"></stop>\r\n            <stop stop-color=\"#5EC56A\" offset=\"91.4063%\"></stop>\r\n            <stop stop-color=\"#5EC56A\" offset=\"91.7969%\"></stop>\r\n            <stop stop-color=\"#5FC56A\" offset=\"92.1875%\"></stop>\r\n            <stop stop-color=\"#60C56B\" offset=\"92.5781%\"></stop>\r\n            <stop stop-color=\"#60C56B\" offset=\"92.9688%\"></stop>\r\n            <stop stop-color=\"#61C66C\" offset=\"93.3594%\"></stop>\r\n            <stop stop-color=\"#62C66C\" offset=\"93.75%\"></stop>\r\n            <stop stop-color=\"#62C66D\" offset=\"94.1406%\"></stop>\r\n            <stop stop-color=\"#63C66D\" offset=\"94.5313%\"></stop>\r\n            <stop stop-color=\"#64C76E\" offset=\"94.9219%\"></stop>\r\n            <stop stop-color=\"#64C76E\" offset=\"95.3125%\"></stop>\r\n            <stop stop-color=\"#65C76E\" offset=\"95.7031%\"></stop>\r\n            <stop stop-color=\"#66C76F\" offset=\"96.0938%\"></stop>\r\n            <stop stop-color=\"#66C76F\" offset=\"96.875%\"></stop>\r\n            <stop stop-color=\"#66C76F\" offset=\"100%\"></stop>\r\n        </linearGradient>\r\n    </defs>\r\n    <g id=\"icon/24/Whatsapp\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"Group-13\" transform=\"translate(10.857050, 5.311759) rotate(44.000000) translate(-10.857050, -5.311759) translate(7.581408, 3.871123)\"></g>\r\n        <g id=\"286165\" filter=\"url(#filter-1)\" transform=\"translate(2.000000, 2.000000)\">\r\n            <path d=\"M10.1463308,17.9371047 C7.61267104,17.9371047 5.5846837,16.582505 5.5846837,16.582505 L2.47246024,17.5872041 L3.4823435,14.6061811 C3.4823435,14.6061811 1.869234,12.3968914 1.869234,9.7484186 C1.869234,5.22591724 5.57500135,1.55973254 10.1463308,1.55973254 C14.7176602,1.55973254 18.4234275,5.22591724 18.4234275,9.7484186 C18.4234275,14.27092 14.7176602,17.9371047 10.1463308,17.9371047 M10.1463308,0 C4.70432416,0 0.292661562,4.36454007 0.292661562,9.7484186 C0.292661562,12.4205675 1.72253785,14.8089644 1.72253785,14.8089644 L0,20 L5.39907563,18.2929695 C5.39907563,18.2929695 7.40349661,19.4968372 10.1463308,19.4968372 C15.5883374,19.4968372 20,15.1322971 20,9.7484186 C20,4.36454007 15.5883374,0 10.1463308,0\" id=\"Shape\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"></path>\r\n            <g id=\"Clipped\" transform=\"translate(1.840735, 1.557744)\">\r\n                <mask id=\"mask-3\" fill=\"white\">\r\n                    <use xlink:href=\"#path-2\"></use>\r\n                </mask>\r\n                <g id=\"Path\"></g>\r\n                <g mask=\"url(#mask-3)\">\r\n                    <g transform=\"translate(0.028316, 0.001988)\">\r\n                        <mask id=\"mask-5\" fill=\"white\">\r\n                            <use xlink:href=\"#path-4\"></use>\r\n                        </mask>\r\n                        <g id=\"Shape\" stroke=\"none\" fill=\"none\"></g>\r\n                        <polygon id=\"Path\" stroke=\"none\" fill=\"url(#linearGradient-6)\" fill-rule=\"nonzero\" mask=\"url(#mask-5)\" points=\"15.4452949 20.4718959 -4.1385484 15.2804988 1.10889857 -4.09434306 20.6929246 1.09705402\"></polygon>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n            <path d=\"M15.1977566,12.0603651 C15.2089004,12.2772456 15.3440874,12.9268028 14.758947,13.5514188 C14.1739893,14.1765769 12.9295384,14.465751 12.3401962,14.3029098 C11.7510367,14.1400687 9.80270009,13.6358214 8.53249056,12.4637629 C7.26173297,11.2913429 6.23285045,10.0572926 5.81194397,9.14765952 C5.39103749,8.23766493 5.41442118,7.6976324 5.43780487,7.44315924 C5.46118857,7.18868608 5.59637554,6.00975962 6.39416136,5.50460875 C6.39416136,5.50460875 6.6603336,5.33761073 6.79917428,5.33761073 L7.57558595,5.33761073 C7.57558595,5.33761073 7.7836643,5.37321528 7.8790259,5.58792701 C7.97457022,5.80245801 8.62931364,7.32387494 8.6779079,7.44080971 C8.72650212,7.55846741 8.85365095,7.84890656 8.64977437,8.10898248 C8.4458978,8.3690584 8.01987613,8.8548708 8.01987613,8.8548708 C8.01987613,8.8548708 7.85107509,9.00469909 7.99740585,9.2443521 C8.14337126,9.48364363 8.65781252,10.272908 9.33027638,10.8693295 C10.0032883,11.4657509 10.8268328,11.9043918 11.2375089,12.0381348 C11.648185,12.1718778 11.7382488,11.9936744 11.8955407,11.7932406 C12.0531979,11.5929875 12.542794,10.9808423 12.542794,10.9808423 C12.542794,10.9808423 12.711595,10.7355865 13.0431685,10.885957 C13.3751073,11.0363275 14.9896783,11.8100488 14.9896783,11.8100488 C14.9896783,11.8100488 15.1866128,11.8433038 15.1977566,12.0603651\" id=\"Path\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"></path>\r\n        </g>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/Whatsapp.52e11d315ed4c3cdeec76c4d4f2cf76d.svg"),
        {
          React: SvgWhatsapp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      